import React, { ChangeEvent, FocusEvent } from 'react';
import Icon from '../../Icon/Icon';

export type Option = {
  label: string;
  value: string | number;
};

type SelectInputProps = {
  className?: string;
  containerClassName?: string;
  name: string;
  id?: string;
  disabled?: boolean;
  error?: boolean;
  placeholder: {
    value: string | number;
    label: string;
  };
  value: string | number;
  options: Option[] | Array<Record<string, Option[]>>;
  onChange: (value: ChangeEvent<HTMLSelectElement>) => void;
  onBlur?: (event: FocusEvent<HTMLSelectElement>) => void;
};

function SelectInput({
  className,
  containerClassName,
  name,
  id,
  disabled,
  error,
  placeholder,
  value,
  onChange,
  onBlur,
  options,
}: SelectInputProps) {
  return (
    <div
      className={`${containerClassName} group inline-block relative h-fit w-full`}
    >
      <select
        name={name}
        id={id}
        value={value}
        disabled={disabled}
        className={`${className} ${error ? 'border-pos-red' : ''} ${
          value
            ? '!text-pos-black !font-poppins !font-normal'
            : '!text-[#d0d7de] text-[15px] !font-poppins !font-light'
        }disabled:border-[#dfe5eb] disabled:bg-[#f5f7fa]`}
        onBlur={onBlur}
        onChange={!disabled ? onChange : undefined}
      >
        <option className="disabled" value={placeholder.value} disabled>
          {placeholder.label}
        </option>
        {options &&
          options.map(optgroup => {
            const groupKeys = Object.keys(optgroup);

            if (
              groupKeys.length > 1 &&
              groupKeys.includes('value') &&
              groupKeys.includes('label')
            ) {
              return (
                <option
                  key={optgroup.value as string | number}
                  value={optgroup.value as string | number}
                >
                  {optgroup.label as string}
                </option>
              );
            }

            const optValues = (optgroup as any)[groupKeys[0]] as Option[];

            return (
              <optgroup key={groupKeys[0]} label={groupKeys[0]}>
                {optValues.map(option => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </optgroup>
            );
          })}
      </select>
      <div className="pointer-events-none absolute inset-y-0 right-[2.5px] flex items-center px-2 text-[#cccccc]">
        <Icon
          id="iconSelectCaret"
          className="inline-block leading-[1] group-hover:fill-[#999999]"
        />
      </div>
    </div>
  );
}

SelectInput.defaultProps = {
  className: '',
  containerClassName: '',
  onBlur: undefined,
  id: undefined,
  disabled: false,
  error: false,
};

export default SelectInput;
